import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-file-uploader-config-view',
  standalone: true,
  templateUrl: './file-uploader-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploaderConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
